export default __webpack_public_path__ + "media/images/images_v2/entete2-8c698185f4333ed798373e678f7e635e.png";